import { type App } from 'vue';

// Import the global options.
import { registerPartial } from '@precon-tools-suite-by-shared/vue-partials';

// Export the composables that you want to use outside of this library.
export * from './composables/useCommonGinoTeam';
export * from './composables/useCurrentTeam';
export * from './composables/useDeleteForms';
export * from './composables/useNodeIsCommon';

export default {
    install(app: App) {
        registerPartial(
            app,
            '@precon-tools-suite-by-shared/precon-tools-monorepo-data-nodes/partials/DeleteNodeForm',
            () => import('./partials/DeleteNodeForm.vue')
        );
        registerPartial(
            app,
            '@precon-tools-suite-by-shared/precon-tools-monorepo-data-nodes/partials/DeleteNodesForm',
            () => import('./partials/DeleteNodesForm.vue')
        );
    },
};
